import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { effect, inject, Injectable, PLATFORM_ID } from '@angular/core';

import { THEME_OPTIONS } from '../core/theme.tokens';
import { ThemeStore } from './theme.store';

@Injectable({
  providedIn: 'root',
})
export class ThemeDomSyncService {
  readonly #document = inject(DOCUMENT);
  readonly #options = inject(THEME_OPTIONS);
  readonly #platformId = inject(PLATFORM_ID);
  readonly #themeStore = inject(ThemeStore);

  readonly #isBrowser = isPlatformBrowser(this.#platformId);

  constructor() {
    effect(() => {
      const theme = this.#themeStore.resolvedTheme();

      if (!this.#isBrowser || !this.#document?.documentElement) {
        return;
      }

      const root = this.#document.documentElement;
      root.setAttribute(this.#options.attributeName, theme);

      if (this.#options.useColorScheme) {
        root.style.colorScheme = `only ${theme}`;
      } else {
        root.style.removeProperty('color-scheme');
      }

      this.#options.onThemeChange?.(theme);
    });
  }
}
